import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { api } from "@/lib/api";

export const RatingPrompts = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/me/rating-prompts").then(({ data }) => setRows(data)).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <div data-testid="rating-prompts" className="mb-6 space-y-2">
      {rows.map((r) => (
        <div key={r.trip_id} data-testid={`rating-prompt-${r.trip_id}`} className="flex items-center gap-3 rounded-xl border border-amber-400/25 bg-amber-400/[0.06] px-4 py-3 text-sm">
          <Star className="h-5 w-5 shrink-0 fill-amber-400 text-amber-400" />
          <p className="mr-auto min-w-0 truncate text-amber-100">How was your trip with {r.other_name}? <span className="text-zinc-500">{r.pickup.split(",")[0]}</span></p>
          <Link to={`/trips/${r.trip_id}/feedback`} data-testid={`rating-prompt-link-${r.trip_id}`} className="whitespace-nowrap font-medium text-amber-300 hover:text-amber-200">Rate now</Link>
        </div>
      ))}
    </div>
  );
};
